import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlGridManagerResult extends IIsiDataTransferObject  {
    nbPages?: number;
    nbRecord?: number;
}
export class IsiDtoPlGridManagerResult extends IsiDataTransferObject implements IIsiDtoPlGridManagerResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.GridManager.IsiDtoPlGridManagerResult, Isilog.IsiComponent.IsiDataTransferObject";
    nbPages?: number;
    nbRecord?: number;

    constructor(data?: IIsiDtoPlGridManagerResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nbPages = _data["nbPages"] !== undefined ? _data["nbPages"] : 0;
            this.nbRecord = _data["nbRecord"] !== undefined ? _data["nbRecord"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoPlGridManagerResult): IsiDtoPlGridManagerResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlGridManagerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["nbPages"] = this.nbPages !== undefined ? this.nbPages : 0;
        data["nbRecord"] = this.nbRecord !== undefined ? this.nbRecord : 0;
        return data;
    }
}
export interface IIsiDtoPlGridManagerResponse extends IIsiDtoPresentationLogicResponse  {
    getCountResult?: IIsiDtoPlGridManagerResult;
}
export class IsiDtoPlGridManagerResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlGridManagerResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.GridManager.IsiDtoPlGridManagerResponse, Isilog.IsiComponent.IsiDataTransferObject";
    getCountResult?: IsiDtoPlGridManagerResult;

    constructor(data?: IIsiDtoPlGridManagerResponse) {
        super(data);
        if (data) {
            this.getCountResult = data.getCountResult && !(<any>data.getCountResult).toJSON ? new IsiDtoPlGridManagerResult(data.getCountResult) : <IsiDtoPlGridManagerResult>this.getCountResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getCountResult = _data["getCountResult"] ? IsiDtoPlGridManagerResult.fromJS(_data["getCountResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlGridManagerResponse): IsiDtoPlGridManagerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlGridManagerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getCountResult"] = this.getCountResult != null ? (<any>this.getCountResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlGridManagerRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlGridManagerResponse;
    clientCtrlsValues?: { [key: string]: string; };
    contextId?: string;
}
export class IsiDtoPlGridManagerRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlGridManagerRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.GridManager.IsiDtoPlGridManagerRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlGridManagerResponse;
    clientCtrlsValues?: { [key: string]: string; };
    contextId?: string;

    constructor(data?: IIsiDtoPlGridManagerRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlGridManagerResponse(data.response) : <IsiDtoPlGridManagerResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlGridManagerResponse.fromJS(_data["response"]) : <any>null;
            this.clientCtrlsValues = _data["clientCtrlsValues"];
            this.contextId = _data["contextId"] !== undefined ? _data["contextId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlGridManagerRequest): IsiDtoPlGridManagerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlGridManagerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["clientCtrlsValues"] = this.clientCtrlsValues !== undefined ? this.clientCtrlsValues : <any>null;
        data["contextId"] = this.contextId !== undefined ? this.contextId : <any>null;
        return data;
    }
}
